import { render, staticRenderFns } from "./CategoryStickyButtons.vue?vue&type=template&id=306fa901&scoped=true&name=sticky-buttons&"
import script from "./CategoryStickyButtons.vue?vue&type=script&lang=js&"
export * from "./CategoryStickyButtons.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStickyButtons.vue?vue&type=style&index=0&id=306fa901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306fa901",
  null
  
)

/* custom blocks */
import block0 from "./CategoryStickyButtons.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports